import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { IDropdownArrowIconProps } from './types';

const COLOR_CLASS_NAME: Record<NonNullable<IDropdownArrowIconProps['color']>, string> = {
  primary: 'text-main',
  secondary: 'text-white',
  info: 'text-[#0288d1]',
  error: 'text-red-500',
  success: 'text-green-500',
  warning: 'text-amber-500',
  disabled: 'text-dust',
  action: 'text-ash',
  inherit: 'text-inherit',
};

export const DropdownArrowIcon: FC<IDropdownArrowIconProps> = ({ isOpen, color = 'info', onClick }) => {
  const Icon = isOpen ? UpOutlined : DownOutlined;

  return (
    <Icon
      className={`${COLOR_CLASS_NAME[color]} text-base [&_path]:stroke-current [&_path]:stroke-40`}
      onClick={onClick}
    />
  );
};
